import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import React, { useEffect, useState } from 'react'

const CategoryCheckbox = ({ setCategory, labels }) => {
    //console.log(labels)

    let stateLabInit = {}

    labels.map((lab) => {
        stateLabInit[lab] = false;
    })

    const [check, setCheck] = useState(stateLabInit);

    const handleChange = (event) => {
        setCheck({
            ...check,
            [event.target.name]: event.target.checked,
        });
        setCategory({
            ...check,
            [event.target.name]: event.target.checked,
        })
    };

    useEffect(() => {
        let stateLab = {}

        labels.map((lab) => {
            stateLab[lab] = false;
        })

        setCheck(stateLab);
    }, [labels])

    useEffect(() => {
        setCategory(check);
        //console.log(check)
    },[check, setCategory, labels])

    return (
        <FormGroup>
            {
                Object.keys(check).map(key =>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={check[key]}
                                onChange={handleChange}
                                name={key}
                                key={key}
                            />
                        }
                        label={key}
                    />
                )
            }

        </FormGroup>
    )
}

export default CategoryCheckbox